import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      // Header / Nav
      nav: {
        marketplace: 'Marketplace',
        contact: 'Contact',
      },
      // Footer
      footer: {
        description: 'A curated selection of vintage watches and authentic spare parts for collectors and enthusiasts.',
        links: 'Links',
        marketplace: 'Marketplace',
      },
      // Sidebar
      sidebar: {
        marketplace: 'Marketplace',
        ourSelection: 'Our Selection',
      },
      // HomePage
      home: {
        heroTitle: 'WatchPassion – Vintage Watches & Spare Parts',
        heroSubtitle: 'Discover our curated selection of vintage watches and authentic spare parts: dials, hands, casebacks, boxes, accessories and much more for collectors and enthusiasts.',
        ourSelection: 'Our Selection',
        banner: '🕐 We are interested in buying watch spare parts and accessories',
        whyTitle: 'Why Choose WatchPassion?',
        whySubtitle: 'We offer a reliable selection of vintage watches and spare parts, with specialized expertise and a dedicated service for collectors.',
        features: {
          premium: { title: 'Premium Selection', desc: 'Our collection includes only original components and watches, selected by experts to guarantee quality and authenticity.' },
          authenticity: { title: 'Guaranteed Authenticity', desc: 'Every spare part and watch is verified and often accompanied by the necessary documentation to guarantee its originality and provenance.' },
          service: { title: 'Specialized Service', desc: 'Professional assistance for special requests, secure shipping, protective packaging and dedicated support for collectors.' },
        },
        processTitle: 'Our Selection Process',
        processSubtitle: 'Discover how we curate our exclusive collection of luxury watches for our most discerning clients.',
        steps: {
          search: { title: 'Expert Selection', desc: 'Our team constantly searches for vintage watches and original spare parts worldwide, working with reliable suppliers and qualified collectors to offer only authentic, quality pieces.' },
          auth: { title: 'Authentication & Inspection', desc: 'Every watch and component is carefully examined through authentication processes and thorough technical checks, guaranteed by our specialists.' },
          cert: { title: 'Certification & Documentation', desc: 'We prepare accurate documentation for each item: detailed description, condition, provenance and checks performed, for maximum transparency.' },
          personal: { title: 'Personalized Experience', desc: 'We support collectors and enthusiasts in finding the ideal component, recommending compatible spare parts, rare pieces and solutions for watch restoration.' },
        },
      },
      // Marketplace page
      marketplace: {
        title: 'Our Selection',
        search: 'Search watches, brands, references...',
        sortBy: 'Sort by',
        relevance: 'Relevance',
        priceAsc: 'Price: lowest first',
        priceDesc: 'Price: highest first',
        newest: 'Newest',
        refresh: 'Refresh',
        update: 'Update',
        noResults: 'No watches found',
        noResultsDesc: 'Try changing the search filters or try again later.',
        reload: 'Reload',
        categories: {
          all: 'All',
          watches: 'Watches',
          watchBox: 'Watch Box',
          spareParts: 'Watch Spare Parts',
          accessories: 'Watch Accessories',
          other: 'Other',
        },
        error: 'An error occurred while loading listings. Please try again later.',
      },
      // Listing detail
      detail: {
        back: 'Back',
        backToMarketplace: 'Back to Marketplace',
        description: 'Description',
        noDescription: 'No description available.',
        showMore: 'Show more ▼',
        showLess: 'Show less ▲',
        condition: 'Condition',
        conditionUnknown: 'Not specified',
        seller: 'Seller',
        professionalSeller: 'Professional seller',
        published: 'Published',
        dateUnavailable: 'Date not available',
        reference: 'Reference',
        shipping: 'Shipping',
        shippingNational: '<strong>NATIONAL</strong> shipments will be sent as soon as possible (1–2 business days maximum). Your shipment will be handled safely by our trusted courier, <strong>DHL Express</strong>. Delivery times from pickup at our premises are normally 48 hours. We will take care to pack items as best as possible to ensure you receive the item in the same condition as shown in the listing photos.',
        shippingInternational: '<strong>INTERNATIONAL</strong> shipments will be handled via <strong>DHL</strong> with variable timing depending on the destination, normally between 48 and 72 hours (except for countries with customs that may require additional time).',
        buyNow: 'Buy now',
        error: 'Error loading listing details. The listing may have been removed or is no longer available.',
        backToMarket: 'Back to marketplace',
        linkCopied: 'Link copied to clipboard!',
      },
      // Contact page
      contact: {
        title: 'Contact Us',
        subtitle: 'We are here for you. Write to us for information, quotes or collaborations.',
        followUs: 'Follow Us',
        formTitle: 'Send a Message',
        name: 'Name',
        email: 'Email *',
        phone: 'Phone number',
        message: 'Message',
        gdprLabel: 'I consent to the processing of my personal data in accordance with the GDPR (EU Regulation 2016/679).',
        gdprLink: 'Learn more',
        send: 'Send',
        sending: 'Sending...',
        successMsg: 'Message sent successfully! We will get back to you shortly.',
        errorMsg: 'An error occurred. Please try again later.',
        errorEmail: 'Email is required.',
        errorEmailInvalid: 'Please enter a valid email address.',
        errorGdpr: 'You must accept the privacy policy to continue.',
      },
      cookie: {
        text: 'This site uses technical cookies necessary for its operation. For more information, see our',
        policy: 'Cookie Policy',
        and: 'and',
        privacy: 'Privacy Policy',
        accept: 'Accept',
        reject: 'Reject',
      },
    },
  },
  it: {
    translation: {
      nav: {
        marketplace: 'Marketplace',
        contact: 'Contatti',
      },
      footer: {
        description: 'Un marketplace sicuro dove collezionisti e appassionati trovano pezzi selezionati e garantiti.',
        links: 'Link',
        marketplace: 'Marketplace',
      },
      sidebar: {
        marketplace: 'Marketplace',
        ourSelection: 'La Nostra Selezione',
      },
      home: {
        heroTitle: 'WatchPassion – Ricambi e Orologi Vintage',
        heroSubtitle: 'Scopri la nostra selezione di orologi vintage e ricambi autentici: quadranti, lancette, fondelli, scatole, accessori e molto altro per collezionisti e appassionati.',
        ourSelection: 'La Nostra Selezione',
        banner: '🕐 Siamo interessati ad acquistare ricambi ed accessori per orologi',
        whyTitle: 'Perché Scegliere WatchPassion?',
        whySubtitle: 'Offriamo una selezione affidabile di ricambi e orologi vintage, con competenza specializzata e un servizio dedicato ai collezionisti.',
        features: {
          premium: { title: 'Selezione Premium', desc: 'La nostra collezione comprende solo componenti e orologi originali, selezionati da esperti per garantire qualità e autenticità.' },
          authenticity: { title: 'Autenticità Garantita', desc: 'Ogni ricambio e ogni orologio è verificato e spesso accompagnato dalla documentazione necessaria per garantirne l\'originalità e la provenienza.' },
          service: { title: 'Servizio Specializzato', desc: 'Assistenza professionale su richieste particolari, spedizioni sicure, imballaggi protettivi e supporto dedicato per collezionisti.' },
        },
        processTitle: 'Il Nostro Processo di Selezione',
        processSubtitle: 'Scopri come curiamo la nostra collezione esclusiva di orologi di lusso per i nostri clienti più esigenti.',
        steps: {
          search: { title: 'Selezione Esperta', desc: 'Il nostro team ricerca costantemente orologi vintage e ricambi originali in tutto il mondo, collaborando con fornitori affidabili e collezionisti qualificati per offrire solo pezzi autentici e di qualità.' },
          auth: { title: 'Autenticazione e Ispezione', desc: 'Ogni orologio e ogni componente viene esaminato con attenzione tramite processi di autenticazione e verifiche tecniche approfondite, garantite dai nostri specialisti.' },
          cert: { title: 'Certificazione e Documentazione', desc: 'Prepariamo una documentazione accurata per ogni articolo: descrizione dettagliata, stato del pezzo, eventuale provenienza e verifiche eseguite, per offrire massima trasparenza.' },
          personal: { title: 'Esperienza Personalizzata', desc: 'Supportiamo collezionisti e appassionati nella ricerca del componente ideale, consigliando ricambi compatibili, pezzi rari e soluzioni per restauri o completamenti di orologi.' },
        },
      },
      marketplace: {
        title: 'La Nostra Selezione',
        search: 'Cerca orologi, marche, riferimenti...',
        sortBy: 'Ordina per',
        relevance: 'Rilevanza',
        priceAsc: 'Prezzo: crescente',
        priceDesc: 'Prezzo: decrescente',
        newest: 'Più recenti',
        refresh: 'Aggiorna',
        update: 'Aggiorna',
        noResults: 'Nessun orologio trovato',
        noResultsDesc: 'Prova a modificare i filtri di ricerca o riprova più tardi.',
        reload: 'Ricarica',
        categories: {
          all: 'Tutti',
          watches: 'Orologi',
          watchBox: 'Scatole',
          spareParts: 'Ricambi',
          accessories: 'Accessori',
          other: 'Altro',
        },
        error: 'Si è verificato un errore nel caricamento degli annunci. Riprova più tardi.',
      },
      detail: {
        back: 'Indietro',
        backToMarketplace: 'Torna al Marketplace',
        description: 'Descrizione',
        noDescription: 'Nessuna descrizione disponibile.',
        showMore: 'Mostra di più ▼',
        showLess: 'Mostra meno ▲',
        condition: 'Condizione',
        conditionUnknown: 'Non specificata',
        seller: 'Venditore',
        professionalSeller: 'Commerciante professionista',
        published: 'Pubblicato',
        dateUnavailable: 'Data non disponibile',
        reference: 'Riferimento',
        shipping: 'Spedizione',
        shippingNational: 'Le spedizioni <strong>NAZIONALI</strong> verranno spedite nel più breve tempo possibile (1-2 giorni lavorativi al massimo). La vostra spedizione verrà gestita in sicurezza dal nostro corriere di fiducia, <strong>DHL Express</strong>. I tempi di consegna dal ritiro del pacco dalla nostra sede sono di norma di 48 ore. Sarà nostra premura imballare al meglio gli articoli per garantirvi di ricevere l\'oggetto nelle medesime condizioni delle foto dell\'annuncio.',
        shippingInternational: 'Le spedizioni <strong>INTERNAZIONALI</strong> verranno gestite tramite <strong>DHL</strong> con tempistiche variabili a seconda della destinazione, di norma tra le 48 e le 72 ore (ad eccezione di paesi con dogana che potrebbero richiedere un tempo aggiuntivo).',
        buyNow: 'Acquista ora',
        error: 'Errore nel caricamento dei dettagli dell\'annuncio. L\'annuncio potrebbe essere stato rimosso o non è più disponibile.',
        backToMarket: 'Torna al mercato',
        linkCopied: 'Link copiato negli appunti!',
      },
      // Pagina contatti
      contact: {
        title: 'Contattaci',
        subtitle: 'Siamo qui per te. Scrivici per informazioni, preventivi o collaborazioni.',
        followUs: 'Seguici sui Social',
        formTitle: 'Invia un Messaggio',
        name: 'Nome',
        email: 'Email *',
        phone: 'Numero di telefono',
        message: 'Messaggio',
        gdprLabel: 'Acconsento al trattamento dei miei dati personali ai sensi del GDPR (Regolamento UE 2016/679).',
        gdprLink: 'Scopri di più',
        send: 'Invia',
        sending: 'Invio in corso...',
        successMsg: 'Messaggio inviato con successo! Ti risponderemo al più presto.',
        errorMsg: 'Si è verificato un errore. Riprova più tardi.',
        errorEmail: 'L\'email è obbligatoria.',
        errorEmailInvalid: 'Inserisci un indirizzo email valido.',
        errorGdpr: 'Devi accettare l\'informativa sulla privacy per continuare.',
      },
      cookie: {
        text: 'Questo sito utilizza cookie tecnici necessari al suo funzionamento. Per maggiori informazioni consulta la nostra',
        policy: 'Cookie Policy',
        and: 'e la',
        privacy: 'Privacy Policy',
        accept: 'Accetta',
        reject: 'Rifiuta',
      },
    },
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  });

export default i18n;
